import { render, staticRenderFns } from "./rename-course.vue?vue&type=template&id=9ae25610&scoped=true"
import script from "./rename-course.vue?vue&type=script&lang=js"
export * from "./rename-course.vue?vue&type=script&lang=js"
import style0 from "./rename-course.vue?vue&type=style&index=0&id=9ae25610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae25610",
  null
  
)

export default component.exports